











































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue';

import SignatureCanvas from '@/modules/files/components/SignatureCanvas.vue';
import { DxColorBox, DxSlider, DxSwitch } from 'devextreme-vue';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxScrollView,
    SignatureCanvas,
    DxColorBox,
    DxSlider,
    DxSwitch,
  },
})
export default class SignaturePopup extends Vue {
    public saving: boolean = false;

    private fullScreen: boolean = false;
    private color: string = '#f05b41';
    private size: number = 5;
    private erase: boolean = false;
    private show: boolean = false;

    public hide() {
        this.show = false;
    }

    public open() {
        this.show = true;
        (this.$refs.SignatureCanvas as SignatureCanvas).setSize();
    }

    private save() {
        const blob = (this.$refs.SignatureCanvas as SignatureCanvas).getDataAsBlob();
        const date = new Date();
        const filename = `${date.getFullYear()}-${date.getMonth()}-${date.getDay()}-${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}.png`;
        this.$emit('sign', {blob, filename});
    }

    private toggleFullScreen() {
        this.fullScreen = !this.fullScreen;
        (this.$refs.SignatureCanvas as SignatureCanvas).setSize();
    }

    get sliderTooltip() {
        return { enabled: true, showMode: 'onHover', position: 'bottom', format: (value: string) => value };
    }
}
